import { DataSource, CollectionViewer } from '@angular/cdk/collections';
import { VehicleGasCard } from './gas-card';
import { Observable, of } from 'rxjs';
export class GasCardDataSource extends DataSource<any> {
    data: Array<VehicleGasCard>;
    connect(): Observable<VehicleGasCard[]> {

        return of(this.data);
    }
    disconnect(collectionViewer: CollectionViewer): void {

    }
    setData(data: Array<VehicleGasCard>) {
        this.data = data;
    }

}
